// Helper function to get initial language
export const getInitialLanguage = () => {
  // First check if there's a stored preference
  const storedLanguage = localStorage.getItem('mobideal-language');
  if (storedLanguage && (storedLanguage === 'EN' || storedLanguage === 'FR')) {
    return storedLanguage;
  }
  
  // If no stored preference, detect system language
  const browserLanguage = navigator.language || navigator.userLanguage;
  // Check if browser language starts with 'fr' (fr, fr-CA, fr-FR, etc.)
  return browserLanguage.toLowerCase().startsWith('fr') ? 'FR' : 'EN';
};

// Function to get brand name based on language
export const getBrandName = (phone, translations, language) => {
  const t = translations[language];
  if (phone.toLowerCase().includes('iphone') || phone.toLowerCase().includes('apple')) {
    return t.apple;
  } else if (phone.toLowerCase().includes('samsung') || phone.toLowerCase().includes('galaxy')) {
    return t.samsung;
  } else if (phone.toLowerCase().includes('google') || phone.toLowerCase().includes('pixel')) {
    return t.google;
  } else if (phone.toLowerCase().includes('moto') || phone.toLowerCase().includes('motorola')) {
    return t.motorola;
  } else {
    return t.others;
  }
};

// Helper function to sort storage capacities intelligently
export const sortStorageCapacities = (storageArray) => {
  return storageArray.sort((a, b) => {
    // Extract numeric value and unit
    const getStorageValue = (storage) => {
      const match = storage.match(/(\d+)(GB|TB)/i);
      if (!match) return 0;
      const value = parseInt(match[1]);
      const unit = match[2].toUpperCase();
      // Convert TB to GB for comparison
      return unit === 'TB' ? value * 1024 : value;
    };
    
    return getStorageValue(a) - getStorageValue(b);
  });
};

// Format price helper
export const formatPrice = (price) => {
  return price != null ? `$${price.toFixed(2)}` : 'N/A';
};

// Get storage color helper
export const getStorageColor = (storage) => {
  const colors = {
    '64GB': { bg: '#EBF8FF', border: '#BEE3F8', text: '#1E40AF' },
    '128GB': { bg: '#F0FDF4', border: '#BBF7D0', text: '#15803D' },
    '256GB': { bg: '#FAF5FF', border: '#E9D5FF', text: '#7C3AED' },
    '512GB': { bg: '#FFF7ED', border: '#FED7AA', text: '#EA580C' },
    '1TB': { bg: '#FEF2F2', border: '#FECACA', text: '#DC2626' },
    'default': { bg: '#F9FAFB', border: '#D1D5DB', text: '#374151' }
  };
  return colors[storage] || colors.default;
};

// Carrier colors and sort order
export const carrierColors = {
  'Bell': '#0066CC',
  'Fido': '#FFD700',
  'Virgin Plus': '#FFFFFF',
  'Rogers': '#E60028',
  'Koodo': '#ADFF2F',
  'Telus': '#50C878',
  'Freedom Mobile': '#FF6600',
  'default': '#3366CC'
};

export const carrierTextColors = {
  'Bell': '#FFFFFF',
  'Fido': '#000000',
  'Virgin Plus': '#E60028',
  'Rogers': '#FFFFFF',
  'Koodo': '#E91E63',
  'Telus': '#7B68EE',
  'Freedom Mobile': '#FFFFFF',
  'default': '#FFFFFF'
};

export const carrierSortOrder = ['Bell', 'Rogers', 'Telus', 'Virgin Plus', 'Fido', 'Koodo', 'Freedom Mobile'];

export const storeColors = {
  'BestBuy': '#0046BE',
  'Costco': '#E31837',
  'Walmart': '#0071CE',
  'Amazon': '#FF9900',
  'Bell': '#0066CC',
  'Rogers': '#E60028',
  'Telus': '#50C878',
  'default': '#8884d8'
};